import React, { useCallback, useEffect, useState } from 'react';

import CloseIcon from '../../images/Close';
import Humburger from '../../images/Humburger';
import Logo from '../../images/logo/Logo';
import { ISiteSettings } from '../common/Layout';
import { SearchForm } from '../SearchForm/SearchForm';
import SideNav from '../SideNav/SideNav';
import SocialLinks from '../SocialLinks/SocialLinks';

import Links from './Links';

import style from './Header.scss';

import cn from 'classnames';

export interface IHeaderProps {
  className?: string;
  site: ISiteSettings;
  postTitle?: string;
}

export default function Header({ className, site, postTitle }: IHeaderProps) {
  const [isSidebarVisible, setSidebarVisibility] = useState(false);
  const [isSearchVisible, setSearchVisible] = useState(false);

  const showSidebarMenu = () => {
    if (!isSidebarVisible) {
      setSidebarVisibility(true);
    }
  };

  const handleSidenavClose = useCallback(() => {
    if (isSidebarVisible) {
      setSidebarVisibility(false);
    }
  }, [isSidebarVisible]);

  const handleSearchToggle = (isVisible: boolean) => {
    setSearchVisible(isVisible);
  };

  const [scrollY, setScrollY] = useState(0);

  function logit() {
    setScrollY(window.pageYOffset);
  }

  useEffect(() => {
    function watchScroll() {
      window.addEventListener('scroll', logit);
    }
    watchScroll();
    // Remove listener (like componentWillUnmount)
    return () => {
      window.removeEventListener('scroll', logit);
    };
  });

  return (
    <>
      <header
        className={cn(className, style.header, {
          [style.scrolled]: scrollY > 1,
          [style.active]: isSearchVisible,
        })}
      >
        {!isSearchVisible && (
          <div
            className={cn(style.postLGTitle, {
              [style.showPostLGTitle]: scrollY > 200 && postTitle,
            })}
          >
            <div className="container">
              <div className="row">
                <h3>{postTitle}</h3>
              </div>
            </div>
          </div>
        )}
        <div className="row align-items-center">
          <div
            className={cn('col-auto d-xl-none', style.toggleButton, {
              ['d-none d-sm-block']: isSearchVisible,
            })}
          >
            <Humburger onClick={showSidebarMenu} aria-label="Open Side Nav" />
          </div>
          <div
            className={cn('col col-xl', style.logo, {
              [style.postTitleLogo]: postTitle,
              ['d-none d-xl-block']: isSearchVisible,
              [style.showTitleLogo]: scrollY > 200 && postTitle,
            })}
          >
            <h3 className="d-lg-none">{postTitle}</h3>
            <a href="/">
              <Logo className={style.animateLogo} />
            </a>
          </div>
          <div
            className={cn(
              isSearchVisible ? 'd-none' : 'd-none d-xl-block col-xl-auto',
              style.links,
              {
                [style.postTitle]: postTitle,
                [style.showTitle]: scrollY > 200 && postTitle,
              }
            )}
          >
            <Links className={style.parent} activeClassName={style.active} />
          </div>
          <div className={cn(' ml-auto', isSearchVisible ? 'col col-sm-auto' : 'col-auto')}>
            <SearchForm callback={handleSearchToggle} />
          </div>
        </div>
      </header>
      <SideNav isOpen={isSidebarVisible} onClose={handleSidenavClose}>
        <button
          className={style.closeButton}
          onClick={handleSidenavClose}
          aria-label="Close Side Nav"
        >
          <CloseIcon />
        </button>
        <Links className={style.sideNavLinks} isSideNav activeClassName={style.active} />
        <SocialLinks className={style.socialLinks} />
        <p className={style.copyright}>
          &copy; {new Date().getFullYear()} {site.title}.
        </p>
      </SideNav>
    </>
  );
}
